// extracted by mini-css-extract-plugin
module.exports =  {"label":"O3n4uC","color-sample":"ZBko4g","colorSample":"ZBko4g","disabled":"eTBpzs","input":"dzUD1t"};